import './App.css';
import Allroutes from './routes';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
    <GoogleOAuthProvider clientId="614320391980-7khsq8i0dao4n9fsufugg2b8vjtqa1hv.apps.googleusercontent.com">
      <Allroutes />
    </GoogleOAuthProvider>
  );
}

export default App;
